import api from './api';

export const notificationService = {
  getAll: async () => {
    return api.get('/notifications');
  },

  markAsRead: async (notificationId) => {
    return api.put(`/notifications/${notificationId}/read`);
  },

  markAllAsRead: async () => {
    return api.put('/notifications/read-all');
  },

  delete: async (notificationId) => {
    return api.delete(`/notifications/${notificationId}`);
  },
};

export default notificationService;
